import { useEffect, useState } from "react";

const shown = new Map<string, number>();
export function IngredientNotice({ id }: { id: string | undefined }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!id) { setVisible(false); return; }
    const expires = shown.get(id) ?? Date.now() + 8000;
    shown.set(id, expires);
    if (shown.size > 100) shown.delete(shown.keys().next().value!);
    if (expires <= Date.now()) { setVisible(false); return; }
    setVisible(true);
    const timer = window.setTimeout(() => setVisible(false), expires - Date.now());
    return () => window.clearTimeout(timer);
  }, [id]);
  return visible ? <p className="nutrition-hint" role="status">Возможно, часть ингредиентов не распознана</p> : null;
}
